export default  '   <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">  '  + 
'   <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">  '  + 
'     '  + 
'   <head>  '  + 
'   	<!--[if gte mso 9]><xml><o:OfficeDocumentSettings><o:AllowPNG/><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->  '  + 
'   	<meta http-equiv="Content-Type" content="text/html; charset=utf-8">  '  + 
'   	<meta name="viewport" content="width=device-width">  '  + 
'   	<!--[if !mso]><!-->  '  + 
'   	<meta http-equiv="X-UA-Compatible" content="IE=edge">  '  + 
'   	<!--<![endif]-->  '  + 
'   	<title></title>  '  + 
'   	<!--[if !mso]><!-->  '  + 
'   	<!--<![endif]-->  '  + 
'   	<style type="text/css">  '  + 
'   		body {  '  + 
'   			margin: 0;  '  + 
'   			padding: 0;  '  + 
'   		}  '  + 
'     '  + 
'   		table,  '  + 
'   		td,  '  + 
'   		tr {  '  + 
'   			vertical-align: top;  '  + 
'   			border-collapse: collapse;  '  + 
'   		}  '  + 
'     '  + 
'   		* {  '  + 
'   			line-height: inherit;  '  + 
'   		}  '  + 
'     '  + 
'   		a[x-apple-data-detectors=true] {  '  + 
'   			color: inherit !important;  '  + 
'   			text-decoration: none !important;  '  + 
'   		}  '  + 
'   	</style>  '  + 
'   	<style type="text/css" id="media-query">  '  + 
'   		@media (max-width: 570px) {  '  + 
'     '  + 
'   			.block-grid,  '  + 
'   			.col {  '  + 
'   				min-width: 320px !important;  '  + 
'   				max-width: 100% !important;  '  + 
'   				display: block !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.block-grid {  '  + 
'   				width: 100% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.col {  '  + 
'   				width: 100% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.col>div {  '  + 
'   				margin: 0 auto;  '  + 
'   			}  '  + 
'     '  + 
'   			img.fullwidth,  '  + 
'   			img.fullwidthOnMobile {  '  + 
'   				max-width: 100% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.no-stack .col {  '  + 
'   				min-width: 0 !important;  '  + 
'   				display: table-cell !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.no-stack.two-up .col {  '  + 
'   				width: 50% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.no-stack .col.num4 {  '  + 
'   				width: 33% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.no-stack .col.num8 {  '  + 
'   				width: 66% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.no-stack .col.num4 {  '  + 
'   				width: 33% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.no-stack .col.num3 {  '  + 
'   				width: 25% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.no-stack .col.num6 {  '  + 
'   				width: 50% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.no-stack .col.num9 {  '  + 
'   				width: 75% !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.video-block {  '  + 
'   				max-width: none !important;  '  + 
'   			}  '  + 
'     '  + 
'   			.mobile_hide {  '  + 
'   				min-height: 0px;  '  + 
'   				max-height: 0px;  '  + 
'   				max-width: 0px;  '  + 
'   				display: none;  '  + 
'   				overflow: hidden;  '  + 
'   				font-size: 0px;  '  + 
'   			}  '  + 
'     '  + 
'   			.desktop_hide {  '  + 
'   				display: block !important;  '  + 
'   				max-height: none !important;  '  + 
'   			}  '  + 
'   		}  '  + 
'   	</style>  '  + 
'   </head>  '  + 
'     '  + 
'   <body class="clean-body" style="margin: 0; padding: 0; -webkit-text-size-adjust: 100%; background-color: #f9f9f9;">  '  + 
'   	<!--[if IE]><div class="ie-browser"><![endif]-->  '  + 
'   	<table class="nl-container" style="table-layout: fixed; vertical-align: top; min-width: 320px; Margin: 0 auto; border-spacing: 0; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #f9f9f9; width: 100%;" cellpadding="0" cellspacing="0" role="presentation" width="100%" bgcolor="#f9f9f9" valign="top">  '  + 
'   		<tbody>  '  + 
'   			<tr style="vertical-align: top;" valign="top">  '  + 
'   				<td style="word-break: break-word; vertical-align: top;" valign="top">  '  + 
'   					<!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color:#f9f9f9"><![endif]-->  '  + 
'   					<div style="background-color:transparent;">  '  + 
'   						<div class="block-grid " style="Margin: 0 auto; min-width: 320px; max-width: 550px; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; background-color: #ffffff;">  '  + 
'   							<div style="border-collapse: collapse;display: table;width: 100%;background-color:#ffffff;">  '  + 
'   								<!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:550px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->  '  + 
'   								<!--[if (mso)|(IE)]><td align="center" width="550" style=";width:550px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:20px; padding-bottom:15px;"><![endif]-->  '  + 
'   								<div class="col num12" style="min-width: 320px; max-width: 550px; display: table-cell; vertical-align: top; width: 550px;">  '  + 
'   									<div style="width:100% !important;">  '  + 
'   										<!--[if (!mso)&(!IE)]><!-->  '  + 
'   										<div style="border-top:0px solid transparent; border-left:0px solid transparent; border-bottom:0px solid transparent; border-right:0px solid transparent; padding-top:20px; padding-bottom:15px; padding-right: 0px; padding-left: 0px;">  '  + 
'   											<!--<![endif]-->  '  + 
'   											<div class="img-container center fixedwidth" align="center" style="padding-right: 0px;padding-left: 0px;">  '  + 
'   												<!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr style="line-height:0px"><td style="padding-right: 0px;padding-left: 0px;" align="center"><![endif]--><img class="center fixedwidth" align="center" border="0" src="https://d15k2d11r6t6rl.cloudfront.net/public/users/BeeFree/beefree-vfpg52lf82m/logo-color.svg" alt="Alternate text" title="Alternate text" style="text-decoration: none; -ms-interpolation-mode: bicubic; height: auto; border: 0; width: 100%; max-width: 165px; display: block;" width="165">  '  + 
'   												<!--[if mso]></td></tr></table><![endif]-->  '  + 
'   											</div>  '  + 
'   											<!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 40px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->  '  + 
'   											<div style="color:#232323;font-family:Montserrat, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif;line-height:1.2;padding-top:40px;padding-right:10px;padding-bottom:10px;padding-left:10px;">  '  + 
'   												<div style="line-height: 1.2; font-size: 12px; color: #232323; font-family: Montserrat, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif; mso-line-height-alt: 14px;">  '  + 
'   													<p style="font-size: 20px; line-height: 1.2; word-break: break-word; text-align: center; mso-line-height-alt: 24px; margin: 0;"><span style="font-size: 20px;">We\'ve got a new user!</span></p>  '  + 
'   												</div>  '  + 
'   											</div>  '  + 
'   											<!--[if mso]></td></tr></table><![endif]-->  '  + 
'   											<div class="img-container center fixedwidth" align="center">  '  + 
'   												<!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr style="line-height:0px"><td style="" align="center"><![endif]--><img class="center fixedwidth" align="center" border="0" src="https://media0.giphy.com/media/4QFzDdeLmo19MTm9AF/giphy.gif?cid=20eb4e9dkgtrfyixl6tkzaep758a022hnzplf026hd4kbs7o&amp;rid=giphy.gif" style="text-decoration: none; -ms-interpolation-mode: bicubic; height: auto; border: 0; width: 100%; max-width: 165px; display: block;" width="165">  '  + 
'   												<!--[if mso]></td></tr></table><![endif]-->  '  + 
'   											</div>  '  + 
'   											<!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 60px; padding-left: 60px; padding-top: 10px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->  '  + 
'   											<div style="color:#555555;font-family:Montserrat, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif;line-height:1.5;padding-top:10px;padding-right:60px;padding-bottom:10px;padding-left:60px;">  '  + 
'   												<div style="line-height: 1.5; font-size: 12px; color: #555555; font-family: Montserrat, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif; mso-line-height-alt: 18px;">  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><span style id="autocomplete"><span style id="autocomplete-delimiter"><strong>Username:</strong> [REGISTRATION_USERNAME]</span></span></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;">&nbsp;</p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><span style><span style><strong>Application Name:</strong> [REGISTRATION_APPNAME]</span></span></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><span style><span style><strong>Application Id:</strong> [REGISTRATION_APPID]</span></span></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;">&nbsp;</p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><span style><span style><strong>Instance:</strong> [REGISTRATION_INSTANCE]</span></span></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><span style><span style><strong>Origin:</strong> [REGISTRATION_ORIGIN]</span></span></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><span style><span style><strong>Timezone:</strong> [REGISTRATION_TIMEZONE]</span></span></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><span style><span style><strong>Local Date and Time:</strong> [REGISTRATION_DATETIME]</span></span></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;">&nbsp;</p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><strong><span style><span style>User Agent:</span></span></strong></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;"><span style><span style>[REGISTRATION_USERAGENT]</span></span></p>  '  + 
'   													<p style="font-size: 14px; line-height: 1.5; word-break: break-word; text-align: justify; mso-line-height-alt: 21px; margin: 0;">&nbsp;</p>  '  + 
'   												</div>  '  + 
'   											</div>  '  + 
'   											<!--[if mso]></td></tr></table><![endif]-->  '  + 
'   											<!--[if (!mso)&(!IE)]><!-->  '  + 
'   										</div>  '  + 
'   										<!--<![endif]-->  '  + 
'   									</div>  '  + 
'   								</div>  '  + 
'   								<!--[if (mso)|(IE)]></td></tr></table><![endif]-->  '  + 
'   								<!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->  '  + 
'   							</div>  '  + 
'   						</div>  '  + 
'   					</div>  '  + 
'   					<!--[if (mso)|(IE)]></td></tr></table><![endif]-->  '  + 
'   				</td>  '  + 
'   			</tr>  '  + 
'   		</tbody>  '  + 
'   	</table>  '  + 
'   	<!--[if (IE)]></div><![endif]-->  '  + 
'   </body>  '  + 
'     '  + 
'  </html>  ' ;